module.exports = __webpack_public_path__ + "static/event8-67e447ddc5546837a2286b08ddf934e0.jpeg";